import { render, staticRenderFns } from "./UiTableBasic.vue?vue&type=template&id=41f73d07&scoped=true&"
import script from "./UiTableBasic.vue?vue&type=script&lang=js&"
export * from "./UiTableBasic.vue?vue&type=script&lang=js&"
import style0 from "./UiTableBasic.vue?vue&type=style&index=0&id=41f73d07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f73d07",
  null
  
)

export default component.exports